import React from 'react';
import PropTypes from 'prop-types';
import { DialogTitle } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { RepliconDialog } from '~/modules/common/components';
import BulkAssignTasksDialogBody from './BulkAssignTasksDialogBody';
import BulkUnassignTasksDialogBody from './BulkUnassignTasksDialogBody';

const TaskAssignmentBulkActionDialog = ({
  open,
  onClose,
  assignedTasksCount,
  impactedTaskCount,
  resource,
  projectId,
  textSearch,
  resetTaskAssignments,
  onTaskAssignmentUpdateSuccess
}) => {
  const isAssignMode = assignedTasksCount === 0;
  const dialogTitleId = isAssignMode
    ? 'taskAssignmentBulkActionDialog.assignAllTasks'
    : 'taskAssignmentBulkActionDialog.removeAllTasksAssignments';
  const dialogDescribedById = isAssignMode
    ? 'bulk-assign-tasks-dialog-description'
    : 'bulk-unassign-tasks-dialog-description';

  return (
    <RepliconDialog
      open={open}
      onClose={onClose}
      aria-labelledby="task-assignment-bulk-action-dialog-title"
      aria-describedby={dialogDescribedById}
      data-qe-id="taskAssignmentBulkActionDialog"
    >
      <>
        <DialogTitle id="task-assignment-bulk-action-dialog-title">
          <FormattedMessage id={dialogTitleId} />
        </DialogTitle>
        {isAssignMode ? (
          <BulkAssignTasksDialogBody
            dialogDescribedById={dialogDescribedById}
            onClose={onClose}
            impactedTaskCount={impactedTaskCount}
            resource={resource}
            projectId={projectId}
            textSearch={textSearch}
            resetTaskAssignments={resetTaskAssignments}
            onTaskAssignmentUpdateSuccess={onTaskAssignmentUpdateSuccess}
          />
        ) : (
          <BulkUnassignTasksDialogBody
            assignedTasksCount={assignedTasksCount}
            dialogDescribedById={dialogDescribedById}
            onClose={onClose}
            resource={resource}
            projectId={projectId}
            textSearch={textSearch}
            resetTaskAssignments={resetTaskAssignments}
            onTaskAssignmentUpdateSuccess={onTaskAssignmentUpdateSuccess}
          />
        )}
      </>
    </RepliconDialog>
  );
};

TaskAssignmentBulkActionDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  assignedTasksCount: PropTypes.number,
  impactedTaskCount: PropTypes.number,
  resource: PropTypes.object.isRequired,
  projectId: PropTypes.string.isRequired,
  textSearch: PropTypes.string,
  resetTaskAssignments: PropTypes.func.isRequired,
  onTaskAssignmentUpdateSuccess: PropTypes.func.isRequired
};

export default TaskAssignmentBulkActionDialog;
